import { get, set } from '../../../../cache';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';

const UPSALE_SERVICE_TYPE_SHOWN = 'UPSALE_SERVICE_TYPE_SHOWN';

const keyGenerator = (orderId: string, type: OrderAdditionalServiceGdsServiceServiceType) =>
	`${UPSALE_SERVICE_TYPE_SHOWN}_${type}_${orderId}`;

export const isUpsaleServiceTypeWasShown = (orderId: string, type: OrderAdditionalServiceGdsServiceServiceType) =>
	get(keyGenerator(orderId, type), false, sessionStorage);

export const setUpsaleServiceTypeWasShown = (orderId: string, type: OrderAdditionalServiceGdsServiceServiceType) =>
	set(keyGenerator(orderId, type), true, sessionStorage);
